export function mapBtcMainnetChainIdToBtc(chainId: string): string {
  if (chainId === 'btc_mainnet') return 'btc';

  return chainId;
}
